import {MANIFEST_POST_SEND_TO_SIGN_CUSTOM} from "../axios";

export const axiosPostSendToSignCustomMan = async (axiosPrivate, manId, getRequestDataToggle, cargoCaseDocId, getIdCreateDoc, getIdUpdateMan, setActiveModal, setTextMessage) => {
    try {
        const response = await axiosPrivate.post(MANIFEST_POST_SEND_TO_SIGN_CUSTOM + manId)
        let promise = new Promise((resolve, reject) => {
            resolve(response)
        })
        promise.then(
            function (response) {
                getRequestDataToggle()
                return new Promise((resolve, reject) => {
                    resolve(response)
                })
            }).then(
            function (response) {
                if (cargoCaseDocId !== undefined) {
                    getIdCreateDoc(cargoCaseDocId)
                    getIdUpdateMan(manId)
                } else {
                    getIdUpdateMan(manId)
                }
            }).catch(
            function (error) {
                console.log(error)
            })
        setActiveModal(false);
    } catch (err) {
        if (err.response?.data[0]?.message === "not issued") {
            setTextMessage('Error sending to release, bills of lading included in the manifest must be implemented or canceled!')
            setActiveModal(false);
        } else {
            console.error(err);
            setActiveModal(false);
            setTextMessage('Document invalidation error! Try again!')
        }
    }
}
